


































































































































// 企业端pc模板
import JSEncrypt from "jsencrypt";
export default {
  name: "enterprise-businessTemplate-pc",
  props: ["config"],
  data() {
    return {
      openEye: false,
      avoid: false,
      clock: false,
      time: 60,
      aggreementList: [
        {
          title: "用户注册协议",
          url: "",
        },
        {
          title: "用户隐私协议",
          url: "",
        },
      ],
      tabList: [
        {
          title: "密码登录",
          type: "password",
          loginAccount: "",
          loginCheckInfo: "",
          testPhone: false,
          testPassword: false,
        },
        {
          title: "验证码登录",
          type: "code",
          loginAccount: "",
          loginCheckInfo: "",
          testPhone: false,
          testCode: false,
        },
      ],
      idx: 0,
    };
  },
  computed: {
    next: function() {
      const instance = this as any;
      const flag =
        instance.tabList[instance.idx].loginAccount &&
        instance.tabList[instance.idx].loginCheckInfo &&
        !instance.tabList[instance.idx].testPhone &&
        !instance.tabList[instance.idx].testPassword &&
        !instance.tabList[instance.idx].testCode;
      return flag;
    },
  },
  watch: {
    avoid: {
      handler(newCul: boolean) {
        const params: any = {
          avoid: newCul,
          time: (this as any).config.loginEffectiveTime || 0,
        };
        (this as any).$emit("avoid-login", params);
      },
      immediate: true,
    },
  },

  methods: {
    limit(key: string) {
      const instance = this as any;
      if (
        key === "loginAccount" &&
        instance.tabList[instance.idx][key].length > 11
      ) {
        instance.tabList[instance.idx][key] = instance.tabList[instance.idx][
          key
        ].slice(0, 11);
      }
    },
    test(key: string) {
      const instance = this as any;
      if (key === "loginAccount") {
        const phoneReg = /^[1][0-9]{10}$/;
        if (
          !instance.tabList[instance.idx][key] ||
          !phoneReg.test(instance.tabList[instance.idx][key])
        ) {
          instance.tabList[instance.idx]["testPhone"] = true;
        } else {
          instance.tabList[instance.idx]["testPhone"] = false;
        }
      }
    },
    clickFun(index: number) {
      (this as any).idx = index;
      console.log(index, "index");
    },
    sendSms() {
      const instance = this as any;
      const phoneReg = /^[1][0-9]{10}$/;
      if (
        !instance.tabList[instance.idx].loginAccount ||
        !phoneReg.test(instance.tabList[instance.idx].loginAccount)
      ) {
        instance.tabList[instance.idx].testPhone = true;
        return;
      }
      instance.clock = true;
      instance.time = 60;
      const inter = setInterval(() => {
        instance.time--;
        if (instance.time <= 0) {
          clearInterval(inter);
          instance.clock = false;
        }
      }, 1000);
      const config = instance.config;
      const params = {
        businessType: 2,
        phone: instance.tabList[instance.idx].loginAccount,
        smsType: config.smsType,
        userType: config.userType,
      };
      instance.$emit("send-sms", params);
    },
    encryptDeal(msg: string) {
      const publicKey =
        "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKbpotLkdWJlxvWuydKwQkryMb3m2mZrj8tizRUbwBW9Bnyu0syIXz+IkxP6Z76b4cEO2NyEq5yPcJdaBKynSVcCAwEAAQ==";

      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      return encrypt.encrypt(msg);
    },
    login() {
      if (!(this as any).next) return;
      const instance = this as any;
      const config = instance.config;
      const params = {
        account: instance.tabList[instance.idx].loginAccount,
        checkInfo: instance.idx
          ? instance.tabList[instance.idx].loginCheckInfo
          : instance.encryptDeal(instance.tabList[instance.idx].loginCheckInfo),
        configId: config.id,
        source: "pc",
        userType: config.userType,
        type: instance.idx ? "02" : "01",
      };
      instance.$emit("login-handle", params);
    },
    goForget() {
      (this as any).$emit("go-forget");
    },
    weiboLogin() {
      const config = (this as any).config;
      const params = {
        configId: config.id,
        source: "pc",
        userType: config.userType,
        registerFrom: String(config.registerFrom),
      };
      (this as any).$emit("weibo-login", params);
    },
  },
};
